import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'inc-modal-footer',
  templateUrl: './footer.component.html'
})
export class FooterComponent implements OnInit {

  @Input() formInvalidity: boolean;
  @Output() result: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() { }

  close() {
    this.result.emit(false);
  }

  save() {
    this.result.emit(true);
  }

}
